export const other = [
    {
        label: 'Entities',
        id: 'ae',
        icon: 'building'
    },
    {
        label: 'Projects',
        id: 'activities',
        icon: 'file-alt'
    },
    {
        label: 'Shared Files',
        id: 'files',
        icon: 'folder-open'
    }
]